import { Typography } from '@material-ui/core';
import React from 'react';
import { MetricCurrency } from './board-metric';
import boardStyles from './board.less';

export const Board = (props) => {
    return (
        <div className={boardStyles.container}>
            <div className={boardStyles.inner}>
                {props.children}
            </div>
        </div>
    );
}

export const BoardItem = (props) => {
    return (
        <div className={boardStyles.item} col={props.col} col-xs={props['col-xs']}>
            {props.children}
        </div>
    );
}

export const BoardTitle = (props) => {
    return (
        <div className={boardStyles.title}>
            <Typography variant="h5">
                {props.title}:
                {props.tooltip || ''}
            </Typography>
            <Typography variant="h5" style={{paddingLeft: '8px'}}>
                <MetricCurrency value={props.value} currency={props.currency} />
            </Typography>
        </div>
    )
}